import { Body2 } from 'components/Typography';
import { Icon, IconName } from '@dapp/multi-lib/sdaoui/Icon';
import React from 'react';

interface VaultInfoItemProps {
  icon: IconName | React.ReactNode;
  label: React.ReactNode | string;
  value: React.ReactNode;
}

export const VaultInfoItem = (props: VaultInfoItemProps) => {
  const { icon, label, value } = props;

  return (
    <div className='flex flex-row items-center gap-2 lg:gap-3'>
      <div className='flex h-[24px] w-[24px] items-center justify-center rounded-full bg-[#2B2B2B] p-1 lg:h-[42px] lg:w-[42px] lg:p-[9px]'>
        {typeof icon === 'string' ? (
          <Icon
            className='w-full'
            icon={icon as IconName}
            height='100%'
            width='100%'
            color={'#B4BCD0'}
          />
        ) : (
          icon
        )}
      </div>
      <div className='flex flex-col'>
        {typeof label === 'string' ? (
          <Body2 className='font-normal text-[#BFBFBF]'>{label}</Body2>
        ) : (
          label
        )}
        {value}
      </div>
    </div>
  );
};
